var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import DefaultHeader from "./DefaultHeader";
import { ExpanderArrow, ExpanderContent, HeaderWrapper } from "./styled";
var Expand = /** @class */ (function (_super) {
    __extends(Expand, _super);
    function Expand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpanded: false
        };
        _this.open = function () { return new Promise(function (resolve) { return _this.setState({ isExpanded: true }, resolve); }); };
        _this.close = function () { return new Promise(function (resolve) { return _this.setState({ isExpanded: false }, resolve); }); };
        _this.toggle = function () { return new Promise(function (resolve) { return _this.setState({ isExpanded: !_this.state.isExpanded }, resolve); }); };
        _this.container = React.createRef();
        return _this;
    }
    Expand.prototype.componentDidUpdate = function (_, prevState) {
        var isExpanded = this.state.isExpanded;
        if (isExpanded !== prevState.isExpanded) {
            this.props.onChange(isExpanded);
        }
    };
    Expand.prototype.render = function () {
        var _a = this.props, Arrow = _a.Arrow, Header = _a.Header, HeaderLabel = _a.HeaderLabel, fullWidth = _a.fullWidth, above = _a.above, children = _a.children, showText = _a.showText, _b = _a.hideText, hideText = _b === void 0 ? showText : _b;
        var isExpanded = this.state.isExpanded;
        var openContent = isExpanded ? React.createElement(ExpanderContent, null, children) : null;
        return (React.createElement("span", { ref: this.container },
            above && openContent,
            React.createElement(HeaderWrapper, { onClick: this.toggle, inline: !fullWidth, fullWidth: fullWidth },
                React.createElement(Header, { renderProps: { HeaderLabel: HeaderLabel, showText: showText, hideText: hideText, isExpanded: isExpanded } }),
                React.createElement(Arrow, { isExpanded: isExpanded, size: 10 })),
            !above && openContent));
    };
    Expand.defaultProps = {
        Header: DefaultHeader,
        Arrow: ExpanderArrow,
        showText: React.createElement(FormattedMessage, { id: "platform.ui.expander.text" }),
        onChange: function () { }
    };
    return Expand;
}(Component));
export default Expand;
